import { __assign } from "tslib";
import { keyCodes } from './key-handled-list/key-handled-list.comp';
import * as React from 'react';
import { renderAndMountComponent } from '@wix/answers-lib';
import { FloaterSelect } from './floater-select.comp';
import { getBaseReactDriver } from '../../common/base-driver';
// tslint:disable-next-line:max-line-length
export function createLegacyFloaterSelectDriver(elem) {
    var base = getBaseReactDriver(elem);
    var searchField = base.find('.search-wrapper .search-input input.input-field');
    return {
        getItemsContent: function () { return base.findAll('.floater-select-item').map(function (item) { return item.getText(); }); },
        search: function (term) { return searchField.enterValue(term); },
        pressDownKey: function () { return searchField.pressKey(keyCodes.downArrow); },
        pressEnterKey: function () { return searchField.pressKey(keyCodes.enter); },
        isLoading: function () { return base.isChildVisible('.loader'); },
        select: function (idx) { return base.findAll('.floater-select-item').get(idx).mouseDown(); },
        base: base
    };
}
export function renderLegacyFloaterSelectAndReturnDriver(props) {
    var elem = renderAndMountComponent(React.createElement(FloaterSelect, __assign({}, props)));
    return createLegacyFloaterSelectDriver(elem);
}
//# sourceMappingURL=floater-select.legacy-driver.js.map